<template>
    <div class="audio_line_box">
        <!-- 音频曲线 -->
        <div v-if="audioObj.is_visible === false"  class="occlusion" @click.stop="()=>{}"></div>
        <div class="music_box_audio">
            <div id="waveform" ref="waveform" >
            </div>
        </div>
    </div>

</template>
<script>
import WaveSurfer from 'wavesurfer.js' //导入wavesurfer.js

export default {
    data() {
        return {
            wavesurfer: null,
        }
    },
    async mounted() {
        //挂载声纹
        await this.init()
    },
    props: {
        audioObj: {
            type: Object,
            default: () => {

            }
        }
    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.wavesurfer = WaveSurfer.create({
                    container: this.$refs.waveform,
                    waveColor: '#DCDCDC',
                    progressColor: '#D92A20',
                    interact: true,
                    backend: 'MediaElement',
                    mediaControls: false,
                    audioRate: '1',
                    barGap:1,
                    barRadius: 1,
                    height: 40,
                    cursorWidth: 0,
                    barWidth: 1,
                    scrollParent: false,
                    hideScrollbar: true,
                    cursor: 'pointer',
                });

                if (this.audioObj.waveform) {
                    let url = JSON.parse(this.audioObj.waveform)
                    this.wavesurfer.load('mp3', url);
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 220px;
    height: 40px;
    background-color: #D92A20;
    z-index: 1;
}

.audio_line_box {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;
    .occlusion{
        position: absolute;
        cursor: not-allowed;
        z-index: 100;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
    }
}

.music_box_audio {
    width: 220px;
    height: 40px;
    position: relative;
    margin-right: 20px;
    color: black;
}

.music_audio_line {
    margin: 0 30px 0 50px;
    width: 440px;


    img {
        width: 440px;
        height: 40px;
    }

}

#waveform {
    position: relative;
    z-index: 2;
    // width: 220px;
    cursor: pointer;

}

.music_time {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
}

.mymusic_time {
    font-size: 12px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}
</style>
